import { FileSpreadsheet, FileText } from "lucide-react";
import { exportToExcel, exportToPDF } from "@/lib/exportUtils";
import { toast } from "sonner";

/**
 * Reusable export buttons.
 * Props:
 *  - filename: base filename
 *  - title, subtitle: for PDF header
 *  - sections: [{ name (Excel sheet), heading (PDF), columns:[{key,label,format,get}], rows:[obj] }]
 *  - orientation: PDF orientation (default: landscape)
 *  - variant: 'default' | 'compact'
 */
export default function ExportButtons({ filename, title, subtitle, sections = [], orientation = "landscape", variant = "default", testidPrefix = "export" }) {
  const doExcel = () => {
    try {
      exportToExcel({ sheets: sections.map(s => ({ name: s.name || s.heading || "Sayfa", columns: s.columns, rows: s.rows })), filename });
      toast.success("Excel indirildi");
    } catch (e) { toast.error(e?.message || "Excel oluşturulamadı"); }
  };
  const doPDF = async () => {
    try {
      await exportToPDF({ title, subtitle, sections, filename, orientation });
      toast.success("PDF indirildi");
    } catch (e) { toast.error(e?.message || "PDF oluşturulamadı"); }
  };

  const btnClass = variant === "compact"
    ? "flex items-center gap-1.5 px-2.5 py-1.5 text-[10px] font-semibold uppercase tracking-widest border border-[#E5E5E5] hover:bg-[#F5F5F5]"
    : "flex items-center gap-2 px-3 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] border border-[#E5E5E5] hover:bg-[#F5F5F5]";
  const iconSize = variant === "compact" ? "w-3 h-3" : "w-3.5 h-3.5";

  return (
    <div className="flex items-center gap-1.5">
      <button data-testid={`${testidPrefix}-excel-btn`} onClick={doExcel} className={btnClass} title="Excel indir">
        <FileSpreadsheet className={`${iconSize} text-[#16A34A]`} />
        Excel
      </button>
      <button data-testid={`${testidPrefix}-pdf-btn`} onClick={doPDF} className={btnClass} title="PDF indir">
        <FileText className={`${iconSize} text-[#DC2626]`} />
        PDF
      </button>
    </div>
  );
}
